module.exports = __webpack_public_path__ + "static/media/venyaa-chemicals.b86a3e39.png";